define('app-Agents/modules/forms/module',["./settings", "./../common/settings"], function (settings) {
    var container = $(settings.container);

    if (container.length === 0) {
        return null;
    }

    var module = {};

    require(["app-Agents/modules/common/module", "jqueryval"], function (common) {
        
        module.createSearchQuerystring = function () {
            if (window.location.pathname.toLowerCase() == "/trade/login" || "/trade/login.aspx" && window.location.search.toLowerCase().indexOf("returnurl=/search") > 0) {
                if (window.location.hash.length > 0 && window.location.hash.indexOf("app-Search") > 0) {
                    $(settings.loginContainer).find('form')[0].action = window.location.origin + window.location.pathname + "?returnUrl=/search%3F" + Math.random() + window.location.hash;
                } else {
                    $(settings.loginContainer).find('form')[0].action = window.location.origin + "/trade/login";
                }
            }
        },

        module.initialise = function (globalSettings) {
            var loginContainer = $(settings.loginContainer);
            var registrationContainer = $(settings.registrationContainer);
            var forgotPasswordContainer = $(settings.forgotPasswordContainer);
            var resetPasswordContainer = $(settings.resetPasswordContainer);
            var forgotEmailContainer = $(settings.forgotEmailContainer);
            var manageBookingContainer = $(settings.manageBookingContainer);

            container.find(settings.elements.agentAbtaNumber).on("keyup", function () {
                var $this = $(this);
                if ($this.val()) {
                    $this.val($this.val().toUpperCase());
                }
            });

            //Because Kiera thought Jase's solution was easier to read :(  
            Object.keys(settings.elements).forEach(function (value) {
                var tag = settings.elements[value];
                container.find(tag).on("blur", function () {
                    var $this = $(this);
                    $this.val($.trim($this.val()));
                });
            });

            loginContainer.find("form").on("submit", function () {
                if ($(this).valid()) common.ShowLoadingScreen("Logging you in...");
            });

            registrationContainer.find("form").on("submit", function () {
                if ($(this).valid()) common.ShowLoadingScreen("Just checking your details...");
            });

            forgotPasswordContainer.find("form").on("submit", function () {
                if ($(this).valid()) common.ShowLoadingScreen("Just checking your details...");
            });

            resetPasswordContainer.find("form").on("submit", function () {
                if ($(this).valid()) common.ShowLoadingScreen("Just checking your details...");
            });

            forgotEmailContainer.find("form").on("submit", function () {
                if ($(this).valid()) common.ShowLoadingScreen("Just checking your details...");
            });
            
            manageBookingContainer.find("form").on("submit", function () {
                if ($(this).valid()) common.ShowLoadingScreen("Just checking your details...");
            });

            module.createSearchQuerystring();
        }
    });

    return module;
});
